// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_062","cls2":"UserTooltip-cls2_JYa UserTooltip-cls1_062"};